import { Col, Container, Row } from "react-bootstrap";
import { CtaCard } from "@/ui/CtaCard";
import { useLocale } from "@/hooks/useLocale";
import { useLink } from "@/hooks/useLink";

export const IR35PageLinksSection = ({ className }) => {
  const locale = useLocale();
  const link = useLink();

  return (
    <div className={className}>
      <Container>
        <Row>
          <Col xs={12} md={6}>
            <CtaCard
              className="mb-4 mb-md-5"
              title={{ path: `page.ir35.cta.1.title.${locale}` }}
              text={{ path: `page.ir35.cta.1.text.${locale}` }}
              url={{ path: `page.ir35.cta.1.url.${locale}`, placeholder: "https://cdn.sourceflow.co.uk/80k9p16hjfo0ypxzj10wudhelgsc" }}
            />
          </Col>
          <Col xs={12} md={6}>
            <CtaCard
              className="mb-4 mb-md-5"
              title={{ path: `page.ir35.cta.2.title.${locale}` }}
              text={{ path: `page.ir35.cta.2.text.${locale}` }}
              url={{ path: `page.ir35.cta.2.url.${locale}`, placeholder: "https://www.crowncommercial.gov.uk/" }}
            />
          </Col>
          <Col xs={12} md={6}>
            <CtaCard
              className="mb-4 mb-md-5"
              title={{ path: `page.ir35.cta.3.title.${locale}` }}
              text={{ path: `page.ir35.cta.3.text.${locale}` }}
              url={{ path: `page.ir35.cta.3.url.${locale}`, placeholder: "https://gravitasrecruitment.kingsbridge.co.uk/buy" }}
            />
          </Col>
          <Col xs={12} md={6}>
            <CtaCard
              className="mb-4 mb-md-5"
              title={{ path: `page.ir35.cta.4.title.${locale}` }}
              text={{ path: `page.ir35.cta.4.text.${locale}` }}
              url={{ path: `page.ir35.cta.4.url.${locale}`, placeholder: "#contactUs" }}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

IR35PageLinksSection.defaultProps = {
  className: "py-4 py-md-5",
};
